import { type Observable, shareReplay } from 'rxjs';
import { map } from 'rxjs/operators';
import { inject, Injectable } from '@angular/core';

import { HttpClient, HttpHeaders } from '@angular/common/http';
import { CookieService } from 'ngx-cookie-service';

type AiData = {
    code: ECodeStatus;
    content: string;
    freeKeyLimit: string;
    freeKeyUsage: number;
    message: string;
    errors: any;
    isFree: boolean;
};

export enum ECodeStatus {
    CONTEXT_LENGTH_EXCEEDED = 'context_length_exceeded',
    INSUFFICIENT_QUOTA = 'insufficient_quota',
}

@Injectable({
    providedIn: 'root',
})
export class AiHttpService {
    protected readonly http = inject(HttpClient);

    cookieService: CookieService = inject(CookieService);

    private readonly baseApiUrlServices = {
        landing: '/api/landings-service',
        ai: '/ai-service',
    };
    public getAiGeneratedText(
        aiData: {
            role: string;
            content: string;
        }[],
        accessToken?: string
    ): Observable<AiData> {
        const cookieAccessToken = this.cookieService.get('oauth_access_token');
        const header = new HttpHeaders().set('Authorization', `Bearer ${accessToken || cookieAccessToken}`);

        return this.http
            .post<AiData>(this.formatAiServiceApiUrl('user-task-message'), { messages: aiData }, { headers: header })
            .pipe(
                shareReplay(),
                map((res) => res)
            );
    }

    private formatAiServiceApiUrl(url: string = ''): string {
        return `${this.baseApiUrlServices.landing}${this.baseApiUrlServices.ai}/${url}`;
    }
}
